import { useMutation } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

/**
 * Completes Google sign-in by posting the authorization code + CSRF state to
 * the backend, which verifies them and establishes the session.
 */
export function useGoogleCallback(onSuccess?: () => void) {
  return useMutation({
    ...orpc.auth.googleLogin.mutationOptions(),
    onSuccess,
  });
}
